<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-7" xl="6">
                        <div class="font-weight-bold body-1">
                            Nuevo Recibo
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="7" xl="6">
                        <v-form ref="form" @submit.prevent="save">
                            <receipt-form :key="componentKey" ref="ReceiptForm" :values="form" @save="save" :serverErrors="serverErrors"></receipt-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="7" xl="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../helpers/Utils';
import ReceiptForm from "./Form.vue";


export default {
    components: {
        'receipt-form': ReceiptForm,
    },
	data(){
		return {
            componentKey: 0,
            loading: false,
            serverErrors: {},
            form: {
                project_id: "",
                receipt_concept_id: "",
                emitted_by: "",
                received_by: "",
                delivered_by: "",
                date: "",
                amount: "",
                reference: ""
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Receipts",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
	methods: {
		validate () {
            //console.log(this.serverErrors);
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
           
          
            // this.forceRerender();
			return this.$refs.form.validate();
            // return true;
		},
        forceRerender() {
            this.componentKey += 1;
        },
         onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                //console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.receipt.store(this.$store.state.business,form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'Receipts'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                //console.log(99, error.response);
                                if(("error" in error.response.data)){
                                    Object.keys(error.response.data.error).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.error;
                                        error.response.data.error[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));
            
            return data;
        }
    },
}
</script>

<style>

</style>